import React, {useState, useEffect, useRef} from "react";
import {addDays, addMonths, format} from "date-fns";
import {DateRangePicker} from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {Container, Card, Form} from "react-bootstrap";
// import "./VendorAssignment.css";
import "./ReportSection.css";
import axios from "../../util/Axios/AxiosInstance";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as ReactBootStrap from "react-bootstrap";
import filterFactory, {textFilter} from "react-bootstrap-table2-filter";
import ToolkitProvider, {
    CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendarDays} from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";
import {event} from "jquery";
import AOS from "aos";
import "aos/dist/aos.css";

function CLRErodeDataReportPage() {
    let [tableData, setTableData] = useState([
        {
            date: <Skeleton/>,
            department: <Skeleton/>,
            subDepartment: <Skeleton/>,
            standardMp: <Skeleton/>,
            requirementsTotal: <Skeleton/>,
            shiftA: <Skeleton/>,
            shiftB: <Skeleton/>,
            shiftC: <Skeleton/>,
            general: <Skeleton/>,
            name: <Skeleton/>
        },
        {
            date: <Skeleton/>,
            department: <Skeleton/>,
            subDepartment: <Skeleton/>,
            standardMp: <Skeleton/>,
            requirementsTotal: <Skeleton/>,
            shiftA: <Skeleton/>,
            shiftB: <Skeleton/>,
            shiftC: <Skeleton/>,
            general: <Skeleton/>,
            name: <Skeleton/>
        },
        {
            date: <Skeleton/>,
            department: <Skeleton/>,
            subDepartment: <Skeleton/>,
            standardMp: <Skeleton/>,
            requirementsTotal: <Skeleton/>,
            shiftA: <Skeleton/>,
            shiftB: <Skeleton/>,
            shiftC: <Skeleton/>,
            general: <Skeleton/>,
            name: <Skeleton/>
        },
        {
            date: <Skeleton/>,
            department: <Skeleton/>,
            subDepartment: <Skeleton/>,
            standardMp: <Skeleton/>,
            requirementsTotal: <Skeleton/>,
            shiftA: <Skeleton/>,
            shiftB: <Skeleton/>,
            shiftC: <Skeleton/>,
            general: <Skeleton/>,
            name: <Skeleton/>
        },
        {
            date: <Skeleton/>,
            department: <Skeleton/>,
            subDepartment: <Skeleton/>,
            standardMp: <Skeleton/>,
            requirementsTotal: <Skeleton/>,
            shiftA: <Skeleton/>,
            shiftB: <Skeleton/>,
            shiftC: <Skeleton/>,
            general: <Skeleton/>,
            name: <Skeleton/>
        },
        {
            date: <Skeleton/>,
            department: <Skeleton/>,
            subDepartment: <Skeleton/>,
            standardMp: <Skeleton/>,
            requirementsTotal: <Skeleton/>,
            shiftA: <Skeleton/>,
            shiftB: <Skeleton/>,
            shiftC: <Skeleton/>,
            general: <Skeleton/>,
            name: <Skeleton/>
        },
        {
            date: <Skeleton/>,
            department: <Skeleton/>,
            subDepartment: <Skeleton/>,
            standardMp: <Skeleton/>,
            requirementsTotal: <Skeleton/>,
            shiftA: <Skeleton/>,
            shiftB: <Skeleton/>,
            shiftC: <Skeleton/>,
            general: <Skeleton/>,
            name: <Skeleton/>
        },
        {
            date: <Skeleton/>,
            department: <Skeleton/>,
            subDepartment: <Skeleton/>,
            standardMp: <Skeleton/>,
            requirementsTotal: <Skeleton/>,
            shiftA: <Skeleton/>,
            shiftB: <Skeleton/>,
            shiftC: <Skeleton/>,
            general: <Skeleton/>,
            name: <Skeleton/>
        },
    ]);
    let [formatDate, setFormatDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [limitRange, setLimitRange] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [rangeValue, setRangeValue] = useState(10);
    const [branchCode, setBranchCode] = useState(
        localStorage.getItem("branchId")
    );
    const [range, setRange] = useState([
        {
            startDate: addMonths(new Date(), -1),
            endDate: new Date(),
            key: "selection",
        },
    ]);
    let [open, setOpen] = useState(false);
    const refSelect = useRef(null);
    const divRef = useRef(null);

    const openState = (e) => {
        e.preventDefault();
        setOpen(!open);
    };

    const handleScroll = () => {
        const div = divRef.current;
        if (div) {
            const isAtBottom = div.scrollTop + div.clientHeight >= div.scrollHeight;
            if (isAtBottom) {
                //   console.log('Scrolled to the bottom!');
                const newLimit = limitRange + 1;
                setLimitRange(newLimit);
                //   console.log(limitRange);
                //getCLRDetailsByBranchIdBetweenDates(branchCode);
            }
        }
    };
    const rangeValueOptions = [
        {label: "10", value: 10},
        {label: "25", value: 25},
        {label: "50", value: 50},
        {label: "100", value: 100},
        {label: "All", value: 5},
    ];

    const newRangeValue = (e) => {
        setLimitRange(0);
        let rValue = e.target.value;
        if (rValue != 5) {
            setRangeValue(rValue);
        } else {
            setRangeValue(5);
        }
    };

    const options = {
        onSizePerPageChange: (sizePerPage, page) => {
            setPageSize(sizePerPage);
        },
        onPageChange: (page, sizePerPage) => {
            setPageNumber(page);
        },
    };
    const getCLRErodeDetails = async (branchId) => {
        try {
            const data = await axios.get("getCLRDetailsByBranchId/" + branchId
            );
            setTableData(data.data);

            setLoading(true);
        } catch (e) {
        }
    };

    const getCLRDetailsByBranchIdBetweenDates = async (
        branchId,
        startRange,
        newRange, rangeValue
    ) => {
        // console.log(branchId);
        // console.log(startRange);
        const startDate = format(newRange[0].startDate, "yyyy-MM-dd");
        const endDate = format(newRange[0].endDate, "yyyy-MM-dd");
        // console.log(startDate);
        // console.log(endDate);
        try {
            const data = await axios.get("getCLRDetailsByBranchIdBetweenDates/" +
                branchId +
                "/" +
                startDate +
                "/" +
                endDate +
                "/" +
                limitRange +
                "/" +
                rangeValue
            );
            if (startRange == 0 || rangeValue == 5) {
                // console.log("here");
                setTableData(data.data);
            } else {
                // console.log("yes");
                setTableData([...tableData, ...data.data]);
                // console.log(tableData);
                // tableData.push(data.data);
            }
            setLoading(true);
        } catch (e) {
        }
    };

    useEffect(() => {
        getCLRDetailsByBranchIdBetweenDates(branchCode, limitRange, range, rangeValue);
        // document.addEventListener("click", hideOnClickOutside, true);
    }, [limitRange, range, rangeValue]);

    useEffect(() => {
        // console.log(open);
    }, [open]);

    useEffect(() => {
        AOS.init();
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let date = new Date();

        const format = months[date.getMonth()] + date.getDate() + ',' + date.getFullYear();
        setFormatDate(format);
    }, [])

    // const hideOnClickOutside = (e) => {
    //     if(refSelect.current && ! refSelect.current.contains(e.target)){
    //         setOpen(false);
    //     }
    // }
    const dateFilteredData = (item) => {
        const newRange = 0;
        setLimitRange(newRange);
        setRange([item.selection]);

        // console.log(range);
        // console.log(newRange);
        // console.log(limitRange);
        getCLRDetailsByBranchIdBetweenDates(branchCode, limitRange, range, rangeValue);
    };

    const onScrollTableEnd = (e) => {
        const target = e.target;
        if (target.scrollHeight - target.scrollTop === target.clientHeight) {
            // console.log("reached Bottom");
        }
    };
    const {ExportCSVButton} = CSVExport;

    const MyExportCSV = (props) => {
        const handleClick = () => {
            props.onExport();
        };
        return (
            <div className="exportButton">
                <button className="btn btn-success" onClick={handleClick}>
                    Export to CSV !!
                </button>
            </div>
        );
    };

    const columns = [
        {
            dataField: "id",
            text: "S No.",
            formatter: (cell, row, rowIndex) => {
                return (pageNumber - 1) * pageSize + (rowIndex + 1);
            },
            headerStyle: (colum, colIndex) => {
                return {width: "60px", textAlign: "center"};
            },
        },
        {dataField: "date", text: "Date", sort: true, filter: textFilter(), 
        title: (cell, row, rowIndex, colIndex) => `${cell}`,},
        {
            dataField: "department",
            text: "Department",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "subDepartment",
            text: "SubDepartment",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "standardMp",
            text: "Standard MP",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "requirementsTotal",
            text: "Requirements Total",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {dataField: "shiftA", text: "Shift A", sort: true, filter: textFilter(),
        title: (cell, row, rowIndex, colIndex) => `${cell}`,},
        {dataField: "shiftB", text: "Shift B", sort: true, filter: textFilter(), 
        title: (cell, row, rowIndex, colIndex) => `${cell}`,},
        {dataField: "shiftC", text: "Shift C", sort: true, filter: textFilter(),
        title: (cell, row, rowIndex, colIndex) => `${cell}`,},
        {dataField: "general", text: "General", sort: true, filter: textFilter(),
        title: (cell, row, rowIndex, colIndex) => `${cell}`,},
        {
            dataField: "name",
            text: "Requested By",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
    ];

    return (
        <Card className="cardStyl">
            <Container fluid className="px-0">
                <div className={"mt-2"}>
                    {/*<h2>Laborer Master</h2>*/}
                    <h5 className={"priColor"}>CLR Erode Data</h5>
                </div>
                <div>
                    <div className={"row"}>
                        <div style={{marginBottom: "10px"}}>
                            {/*<button className={"btn btn-primary"} variant="primary"*/}
                            {/*        style={{ float: "left" }}*/}
                            {/*        >*/}
                            {/*    Filter*/}
                            {/*</button>*/}
                            {/* <button className={"btn btn-primary"} variant="primary"
                                style={{ float: "right" }}
                                onClick={(e)=> HandleEvent(7.1)}>
                            Add New
                        </button> */}
                        </div>
                    </div>
                    <div className="subDiv">
                        <div className={"inputImage"}>
                            <input
                                value={`${format(range[0].startDate, "dd/MM/yyyy")} - ${format(
                                    range[0].endDate,
                                    "dd/MM/yyyy"
                                )}`}
                                className="inputElement"
                                readOnly
                                onClick={(e) => openState(e)}
                            />
                            <FontAwesomeIcon
                                icon={faCalendarDays}
                                className="Calendericon"
                                onClick={(e) => openState(e)}
                            />
                        </div>
                        <div>
                            <Form.Select className="selectSize" value={rangeValue} onChange={newRangeValue}>
                                {rangeValueOptions.map((rangeValueOption) => (
                                    <option value={rangeValueOption.value}>{rangeValueOption.label}</option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>
                    <div ref={refSelect}>
                        {open === true && (
                            <div className={"daterangepickerdiv"}>
                                <DateRangePicker
                                    onChange={(item) => dateFilteredData(item)}
                                    editableDateInputs={true}
                                    showSelectionPreview={true}
                                    moveRangeOnFirstSelection={false}
                                    months={2}
                                    ranges={range}
                                    direction="horizontal"
                                />
                            </div>
                        )}
                    </div>
                    <div>
                        <ToolkitProvider
                            keyField="id"
                            data={tableData}
                            columns={columns}
                            exportCSV={{
                                fileName: "CLRData" + '  ' + formatDate + ".csv",
                                onlyExportFiltered: true,
                                exportAll: false,
                            }}
                        >
                            {(props) => (
                                <React.Fragment>
                                    {loading ? <MyExportCSV {...props.csvProps} /> : ""}
                                    <div data-aos="zoom-in-right" data-aos-duration="550"
                                         ref={divRef}
                                         style={{
                                             height: "380px",
                                             overflow: "auto",
                                         }}
                                         onScroll={handleScroll}
                                    >
                                        <BootstrapTable
                                            bootstrap4
                                            wrapperClasses="table-responsive"
                                            filter={filterFactory()}
                                            {...props.baseProps}
                                        />
                                    </div>
                                </React.Fragment>
                            )}
                        </ToolkitProvider>
                    </div>
                </div>
            </Container>
        </Card>
    );
}

export default CLRErodeDataReportPage;
